import PDFViewer from "./PDFViewer";
import { ButtonBase } from "@reusejs/react";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";

const BiddersApplicationResult = ({
  bidderData,
  id,
  currentStep,
  nextStep,
}: any) => {
  const router = useRouter();

  console.log("bidderData:::>", bidderData);
  const handleSubmit = async () => {
    router.push(`/kyc`);
  };
  return (
    <div className="min-h-screen mx-auto">
      <div className="mx-auto max-w-5xl border py-6 px-12 rounded-md space-y-6">
        <div className="flex flex-col justify-center items-center">
          <h2 className="font-bold tracking-wide text-2xl">
            Esigned Application
          </h2>
          <p className="tracking-tighter pt-1 text-gray-400">
            Your application has been esigned
          </p>
        </div>
        <div className="flex justify-center">
          <PDFViewer
            pdf_url={
              bidderData?.esigned_data?.esign_response?.finalSignedContract
                ? bidderData?.esigned_data?.esign_response?.finalSignedContract
                : bidderData?.esigned_data?.signer_response
                    ?.signerSignedContract
            }
          />
        </div>
        <div className="flex justify-end text-center pt-2">
          <ButtonBase
            variant="primary"
            type="button"
            label={"Save & Submit"}
            onClick={() => handleSubmit()}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-green-600 hover:bg-green-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-2",
            }}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      </div>
    </div>
  );
};

export default BiddersApplicationResult;
